import { computed, ref, shallowRef } from "vue";
import {
  hasRightInSnapshot,
  hasRightOnAnySiteInSnapshot,
  type AuthorizationSnapshot,
} from "./authorizationGrant";

export const authorizationSnapshot = shallowRef<AuthorizationSnapshot | null>(null);
export const authorizationStale = ref(true);
export const authorizationLoading = ref(false);
export const authorizationReady = computed(
  () => authorizationSnapshot.value !== null && !authorizationStale.value,
);

export function hasRight(right: string, siteId?: number | null): boolean {
  return authorizationReady.value && hasRightInSnapshot(authorizationSnapshot.value, right, siteId);
}

export function hasRightOnAnySite(right: string): boolean {
  return (
    authorizationReady.value && hasRightOnAnySiteInSnapshot(authorizationSnapshot.value, right)
  );
}
